<template>
    <RichTextEditor
        ref="richTextEditor"
        toolbar="#client-note-editor-toolbar"
        :content="comments"
        :placeholder="$t('Add additional information about the client, such as special agreements, passwords, etc.')"
        @input="$emit('change', $event)"
    />
</template>

<script>
import fileChip from "../../components/fileChip";
import { $t } from "@/i18n";
import RichTextEditorToolbar from "../../components/RichTextEditor/RichTextEditorToolbar";
import RichTextEditor from "../../components/RichTextEditor/RichTextEditor";

export default {
    name: "NoteEditView",
    components: {
        fileChip,
        RichTextEditorToolbar,
        RichTextEditor
    },
    props: {
        editNote: {
            type: Object,
            default: () => {}
        },
        comments: {
            type: String,
            required: true
        },
        handleFilesUpload: {
            type: Function,
            required: true
        }
    },
    setup() {
        return {
        };
    }
};
</script>
